import { ArrowUpRight, MessageCircle } from "lucide-react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { getWhatsAppLink, SITE } from "@/config/site";

export const FinalCta = () => {
  const sectionRef = useRef(null);
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const firstLineX = useTransform(scrollYProgress, [0, 1], [reduceMotion ? "0%" : "2%", "0%"]);
  const secondLineX = useTransform(scrollYProgress, [0, 1], ["0%", reduceMotion ? "0%" : "2%"]);

  return (
    <section
      ref={sectionRef}
      data-header-theme="light"
      className="overflow-hidden bg-lime-300 text-[#050606]"
      data-testid="final-cta-section"
    >
      <div className="site-shell flex min-h-[76svh] flex-col justify-between py-16 md:py-24">
        <div className="flex items-center justify-between gap-6 border-b border-black/20 pb-5">
          <p className="text-[11px] font-bold uppercase tracking-[.2em]">O próximo passo</p>
          <p className="hidden text-xs font-medium text-black/55 sm:block">Uma conversa clara. Um caminho possível.</p>
        </div>

        <div className="my-16 md:my-24">
          <motion.h2
            style={{ x: firstLineX }}
            className="display-title whitespace-nowrap text-[clamp(3.15rem,7.6vw,8rem)] leading-[.88]"
          >
            A próxima versão
          </motion.h2>
          <motion.h2
            style={{ x: secondLineX }}
            className="display-title mt-2 text-[clamp(3.15rem,7.6vw,8rem)] leading-[.88] md:mt-4"
          >
            começa com uma conversa.
          </motion.h2>
        </div>

        <div className="grid gap-9 border-t border-black/20 pt-7 md:grid-cols-[minmax(0,1fr)_auto] md:items-end md:gap-16">
          <p className="max-w-xl text-base leading-relaxed text-black/65 md:text-lg">
            Conte o que hoje trava sua operação. A gente transforma o cenário em um próximo passo claro, útil e construído para a sua realidade.
          </p>

          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href={getWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-14 items-center justify-center gap-3 border border-black/25 px-6 text-sm font-bold transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
              aria-label={`Conversar pelo WhatsApp no número ${SITE.phoneDisplay}`}
            >
              <MessageCircle size={18} strokeWidth={1.8} />
              WhatsApp
            </a>
            <Link
              to="/contato"
              className="group inline-flex min-h-14 items-center justify-center gap-5 bg-[#050606] px-7 text-sm font-bold text-white transition-colors hover:bg-black/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-lime-300"
              data-testid="final-cta-button"
            >
              Começar um projeto
              <ArrowUpRight className="transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" size={19} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
